import { render, staticRenderFns } from "./screenChroma.vue?vue&type=template&id=4200e329&scoped=true"
import script from "./screenChroma.vue?vue&type=script&lang=js"
export * from "./screenChroma.vue?vue&type=script&lang=js"
import style0 from "./screenChroma.vue?vue&type=style&index=0&id=4200e329&prod&lang=scss&scoped=true"
import style1 from "./screenChroma.vue?vue&type=style&index=1&id=4200e329&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4200e329",
  null
  
)

export default component.exports